module.exports = __webpack_public_path__ + "img/icon-duplicate.792e619d.svg";